import React from 'react';
import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';

const AddMediaComponent = ({ initialValues, onChange, validationSchema, FormikContext }) => (
  <div className="p-4 bg-white rounded-sm">
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount
    >
      {() => (
        <Form className="flex flex-col gap-4">
          <p className="text-[0.875rem] text-left text-[#303030]">
            Preencha todos os campos abaixo.
          </p>
          
          <div className="flex flex-col text-left gap-1">
            <label 
              htmlFor="external-id" 
              className="text-[0.75rem] font-bold uppercase text-[#393939]"
            >
              ID do Banib *
            </label>
            <Field 
              type="text" 
              name="external_id" 
              id="external-id" 
              required 
              className="h-[40px] px-3 border border-[#e3e3e3] rounded-[3px] font-semibold text-[0.875rem] text-[#919191] focus:border-[#5882C1] focus:outline-0 transition-all"
            />
          </div>

          <div className="flex flex-col text-left gap-1">
            <label 
              htmlFor="external-uri" 
              className="text-[0.75rem] font-bold uppercase text-[#393939]"
            >
              Link do tour virtual *
            </label>
            <Field 
              type="text" 
              name="external_uri" 
              id="external-uri" 
              required 
              className="h-[40px] px-3 border border-[#e3e3e3] rounded-[3px] font-semibold text-[0.875rem] text-[#919191] focus:border-[#5882C1] focus:outline-0 transition-all"
            />
          </div>
          
          <FormikContext onChange={onChange} />
        </Form>
      )}
    </Formik>
  </div>
);

AddMediaComponent.propTypes = {
  initialValues: PropTypes.object.isRequired,
  FormikContext: PropTypes.elementType.isRequired,
  validationSchema: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AddMediaComponent;
